/* ========================================
   A-Hill Store — Theme JavaScript
   ======================================== */

(function () {
  'use strict';

  /* ---------- Mobile Menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.setAttribute('aria-hidden', String(expanded));
      document.body.style.overflow = expanded ? '' : 'hidden';
    });
  }

  /* ---------- Sticky Header ---------- */
  var header = document.querySelector('[data-header]');

  if (header && header.classList.contains('header--sticky')) {
    var onScroll = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product Gallery Thumbnails ---------- */
  var thumbnails = document.querySelectorAll('[data-thumbnail]');
  var mainImage = document.querySelector('[data-main-image]');

  if (thumbnails.length && mainImage) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-image-url');
        mainImage.srcset = thumb.getAttribute('data-image-srcset') || '';
        mainImage.alt = thumb.getAttribute('data-image-alt') || '';
        mainImage.width = thumb.getAttribute('data-image-width') || '';
        mainImage.height = thumb.getAttribute('data-image-height') || '';

        thumbnails.forEach(function (t) {
          t.classList.remove('product-info__thumbnail--active');
        });
        thumb.classList.add('product-info__thumbnail--active');
      });
    });
  }

  /* ---------- Quantity Selectors ---------- */
  document.querySelectorAll('[data-quantity-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-info__quantity-selector').querySelector('[data-quantity-input]')
                  || btn.parentNode.querySelector('input[type="number"]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        var min = parseInt(input.min, 10) || 1;
        if (val > min) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  document.querySelectorAll('[data-quantity-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.closest('.product-info__quantity-selector').querySelector('[data-quantity-input]')
                  || btn.parentNode.querySelector('input[type="number"]');
      if (input) {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  /* ---------- Variant Selection ---------- */
  var productForm = document.querySelector('[data-product-form]');
  var productJsonEl = document.querySelector('[data-product-json]');

  if (productForm && productJsonEl) {
    try {
      var productData = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      productData = null;
    }

    if (productData) {
      var optionSelects = productForm.querySelectorAll('[data-option-select]');

      function updateVariantState() {
        var selectedOptions = [];
        optionSelects.forEach(function (s) {
          selectedOptions.push(s.value);
        });

        var matchedVariant = productData.variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (matchedVariant) {
          var variantInput = productForm.querySelector('[data-variant-id]');
          if (variantInput) variantInput.value = matchedVariant.id;

          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl) {
            priceEl.textContent = formatMoney(matchedVariant.price);
          }

          var compareEl = document.querySelector('[data-compare-price]');
          var discountBadge = document.querySelector('[data-discount-badge]');
          if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
            if (compareEl) {
              compareEl.textContent = formatMoney(matchedVariant.compare_at_price);
              compareEl.hidden = false;
            }
            if (discountBadge) {
              var pct = Math.round((matchedVariant.compare_at_price - matchedVariant.price) * 100 / matchedVariant.compare_at_price);
              discountBadge.textContent = '-' + pct + '%';
              discountBadge.hidden = false;
            }
          } else {
            if (compareEl) compareEl.hidden = true;
            if (discountBadge) discountBadge.hidden = true;
          }

          var stickyPrice = document.querySelector('[data-sticky-price]');
          if (stickyPrice) {
            stickyPrice.textContent = formatMoney(matchedVariant.price);
          }

          var addBtn = document.querySelector('[data-add-to-cart]');
          if (addBtn) {
            if (matchedVariant.available) {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to cart';
            } else {
              addBtn.disabled = true;
              addBtn.textContent = addBtn.getAttribute('data-sold-text') || 'Sold out';
            }
          }

          var stickyBar = document.querySelector('[data-sticky-atc]');
          if (stickyBar) {
            stickyBar.hidden = !matchedVariant.available;
          }

          if (matchedVariant.featured_image) {
            var mainImg = document.querySelector('[data-main-image]');
            if (mainImg) {
              mainImg.src = matchedVariant.featured_image.src;
            }
          }
        }
      }

      optionSelects.forEach(function (select) {
        select.addEventListener('change', updateVariantState);
      });

      // Sync state on page load so button reflects the pre-selected variant
      updateVariantState();

      // If the initially-selected variant is unavailable (e.g. user arrived via a
      // ?variant= URL pointing to an out-of-stock variant), automatically switch to
      // the first available variant so an in-stock product never appears sold out.
      var initialVariantId = parseInt((productForm.querySelector('[data-variant-id]') || {}).value, 10);
      var initialVariant = productData.variants.find(function (v) { return v.id === initialVariantId; });
      if (initialVariant && !initialVariant.available) {
        var firstAvailable = productData.variants.find(function (v) { return v.available; });
        if (firstAvailable) {
          firstAvailable.options.forEach(function (opt, i) {
            if (optionSelects[i]) optionSelects[i].value = opt;
          });
          updateVariantState();
          // Update the URL so it reflects the switched variant without adding a history entry
          if (history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', firstAvailable.id);
            history.replaceState({}, '', url.toString());
          }
        }
      }
    }
  }

  /* ---------- Product Tabs ---------- */
  var tabsContainer = document.querySelector('[data-tabs]');

  if (tabsContainer) {
    var tabButtons = tabsContainer.querySelectorAll('[data-tab-button]');
    var tabPanels = tabsContainer.querySelectorAll('[data-tab-panel]');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('aria-controls');

        tabButtons.forEach(function (btn) {
          btn.classList.remove('product-tabs__tab--active');
          btn.setAttribute('aria-selected', 'false');
        });

        tabPanels.forEach(function (panel) {
          panel.classList.remove('product-tabs__panel--active');
          panel.hidden = true;
        });

        button.classList.add('product-tabs__tab--active');
        button.setAttribute('aria-selected', 'true');

        var activePanel = document.getElementById(target);
        if (activePanel) {
          activePanel.classList.add('product-tabs__panel--active');
          activePanel.hidden = false;
        }
      });
    });
  }

  /* ---------- Sticky Add-to-Cart Bar ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');

  if (stickyBar && addToCartBtn) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });

    observer.observe(addToCartBtn);

    var stickyAtcBtn = document.querySelector('[data-sticky-atc-btn]');
    if (stickyAtcBtn) {
      stickyAtcBtn.addEventListener('click', function () {
        addToCartBtn.click();
      });
    }
  }

  /* ---------- Product Recommendations ---------- */
  var relatedSection = document.querySelector('[data-related-products]');

  if (relatedSection) {
    var productId = relatedSection.getAttribute('data-product-id');
    var sectionId = relatedSection.getAttribute('data-section-id');
    var limit = relatedSection.getAttribute('data-limit') || 4;
    var baseUrl = relatedSection.getAttribute('data-url');

    if (productId && sectionId && baseUrl) {
      var recUrl = baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit;

      fetch(recUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var grid = doc.querySelector('.related-products__grid');
          var localGrid = relatedSection.querySelector('.related-products__grid');
          if (grid && localGrid && grid.childElementCount > 0) {
            localGrid.innerHTML = grid.innerHTML;
          } else {
            relatedSection.hidden = true;
          }
        })
        .catch(function () {
          relatedSection.hidden = true;
        });
    }
  }

  /* ---------- Collection: Live Availability Check ---------- */
  // Shopify caches collection page HTML for anonymous visitors. Products that
  // were OOS at cache-render time show the sold-out badge even after restocking.
  // This check uses only CSS classes and URL patterns present in ALL cached HTML
  // (no new data-* attributes required) so it works even on stale cached pages.
  var soldOutBadges = document.querySelectorAll('.collection-page__grid .badge--sold-out, [data-collection-grid] .badge--sold-out');

  if (soldOutBadges.length) {
    soldOutBadges.forEach(function (badge) {
      var card = badge.closest('.product-card');
      if (!card) return;

      // Derive the handle from the existing product URL — e.g. /products/my-handle
      var productLink = card.querySelector('.product-card__link');
      if (!productLink) return;
      var match = productLink.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (!match) return;
      var handle = match[1];

      // Fetch live inventory — cache-bust so Shopify CDN doesn't serve stale data
      fetch('/products/' + handle + '.js?t=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (product) {
          if (!product.available) return; // genuinely out of stock — leave badge

          // Remove the stale sold-out badge
          badge.remove();

          // The quick-add button was not server-rendered (product was OOS), so inject one
          if (!card.querySelector('.product-card__quick-add, .btn--secondary')) {
            var isLv = document.documentElement.lang === 'lv';
            var actionEl;
            if (product.variants && product.variants.length === 1) {
              actionEl = document.createElement('form');
              actionEl.method = 'post';
              actionEl.action = '/cart/add';
              actionEl.className = 'product-card__quick-add';
              actionEl.innerHTML =
                '<input type="hidden" name="id" value="' + product.variants[0].id + '">' +
                '<input type="hidden" name="quantity" value="1">' +
                '<button type="submit" class="btn btn--primary btn--small btn--full">' +
                (isLv ? 'Pievienot grozam' : 'Add to cart') +
                '</button>';
            } else {
              actionEl = document.createElement('a');
              actionEl.href = productLink.getAttribute('href');
              actionEl.className = 'btn btn--secondary btn--small btn--full';
              actionEl.textContent = isLv ? 'Izvēlieties opcijas' : 'Choose options';
            }
            card.appendChild(actionEl);
          }
        })
        .catch(function () { /* fail silently — stale badge stays */ });
    });
  }

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR'
    });
  }
})();
